import { Component } from '@angular/core';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';

@Component({
  selector: 'cwo-hourglass',
  standalone: true,
  imports: [LottieComponent],
  templateUrl: './hourglass.component.html',
  styleUrl: './hourglass.component.scss'
})
export class HourglassComponent {
  options: AnimationOptions = {
    path: '/assets/animations/hourglass.json',
    loop: true,
    autoplay: true,
  };

}